import moment from "moment";

function getAge(dateString): number {
  const today = new Date();
  const birthDate = new Date(dateString);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

function formatDMYDate(dateString): string {
  return dateString
    .split("-")
    .reverse()
    .join("-");
}

function formatToYMDDate(date): string {
  const d = new Date(date),
    year = d.getFullYear();

  let month = "" + (d.getMonth() + 1),
    day = "" + d.getDate();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

function getHumanDateTime(date) {
  return date
    ? moment(date, "YYYY-MM-DD HH:mm:ss").format("DD MMMM YYYY HH:mm")
    : "";
}

function getFormattedDateTime(
  date,
  toFormat = "DD-MM-YYYY HH:mm:ss",
  fromFormat = "YYYY-MM-DD HH:mm:ss"
) {
  return date ? moment(date, fromFormat).format(toFormat) : "";
}

export {
  getAge,
  formatDMYDate,
  formatToYMDDate,
  getHumanDateTime,
  getFormattedDateTime
};
